var map = {
	"./CollectionsTeaser": [
		6826,
		826
	],
	"./CollectionsTeaser.vue": [
		6826,
		826
	],
	"./GridBlock": [
		4265,
		265
	],
	"./GridBlock.vue": [
		4265,
		265
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 8749;
module.exports = webpackAsyncContext;